export const getFormattedStatus = (
  status,
  paid = null,
  payable = null,
  returnPeriod = null,
  expired = null
) => {
  switch (status) {
    case 'paid':
      return paid;
    case 'payable':
      return payable;
    case 'awaiting return period':
      return returnPeriod;
    case 'expired':
      return expired;
    default:
      return 'No status';
  }
};

export default getFormattedStatus;
